import { Icon } from '@iconify/react/dist/iconify.js';
import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
} from '@heroui/react';
import type { ActionKey } from './columns';
import type { User } from '@/shared/types/user';

interface UserAction {
  key: ActionKey;
  label: string;
  filter?: (item: User) => boolean;
}

const AllActions: UserAction[] = [
  {
    key: 'edit',
    label: 'Edit',
  },
  {
    key: 'archive',
    label: 'Archive',
    filter: (item: User) => !item.data.archived,
  },
  {
    key: 'invite',
    label: 'Resend Invite',
    filter: (item: User) => !item.data.archived && !item.data.active,
  },
];

export function UserActions({
  item,
  onAction,
}: {
  item: User;
  onAction: (item: User, action: ActionKey) => void;
}) {
  const actions = AllActions.filter(
    (action) => !action.filter || action.filter(item),
  );

  return (
    <Dropdown>
      <DropdownTrigger>
        <Button isIconOnly variant='light'>
          <Icon
            icon='mdi:dots-vertical'
            width={22}
            height={22}
            className='text-gray-600'
          />
        </Button>
      </DropdownTrigger>
      <DropdownMenu>
        {actions.map((action) => (
          <DropdownItem
            key={action.key}
            onClick={() => onAction(item, action.key)}
          >
            {action.label}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
}
